let getSlopeInfoServiceList = (baseManMadeSlopeInfoListUrl = "") => (
  (baseManMadeSlopeInfoListUrl += "/ginfo_srv/api/WebAPI/GInfo"),
  {
    ManMadeFeatureUrl: `${baseManMadeSlopeInfoListUrl}/ManMadeFeature`,
    photoUrl: `${baseManMadeSlopeInfoListUrl}/Photos`,
    SMRISsUrl: `${baseManMadeSlopeInfoListUrl}/SMRISs`,
    SCSUrl: `${baseManMadeSlopeInfoListUrl}/SCS`,
    FSRUrl: `${baseManMadeSlopeInfoListUrl}/FSR`,
    eLPMISUrl: `${baseManMadeSlopeInfoListUrl}/S23StudyWorks`,
    S23ReportUrl: `${baseManMadeSlopeInfoListUrl}/S23Reports`,
    boulderUrl: `${baseManMadeSlopeInfoListUrl}/Boulder`,
    ESFSUrl: `${baseManMadeSlopeInfoListUrl}/ESFS`,
    OldFeaturesUrl: `${baseManMadeSlopeInfoListUrl}/OldFeatures`,
    MMReportUrl: `${baseManMadeSlopeInfoListUrl}/MMReports`,
  }
);
export default getSlopeInfoServiceList;
